import React from 'react';
import { useTranslation } from '../i18n';
import StructuredMessageRenderer from './StructuredMessageRenderer';

export default function RoteiroView({ itinerary, onShareItinerary, onCopyCurrentUrl, copiedToClipboard, setCopiedToClipboard }) {
  const { t } = useTranslation();

  if (!itinerary) {
    return (
      <div className="roteiro-loading">
        <p>{t('chat.empty')}</p>
      </div>
    );
  }

  // Create a modified itinerary without introduction and finalization
  const itineraryOnly = {
    ...itinerary,
    introduction: '',
    finalization: ''
  };

  return (
    <div className="roteiro-view">
      <div className="roteiro-header">
        <p className="roteiro-message">{t('share.sharedItineraryMessage')}</p>
        <div style={{ position: 'relative' }}>
          <button
            type="button"
            className="share-pdf-btn"
            onClick={onCopyCurrentUrl}
          >
            <span className="material-symbols-outlined">share</span>
          </button>
          {copiedToClipboard && (
            <div className="share-tooltip show">
              {t('share.linkCopied')}
            </div>
          )}
        </div>
      </div>
      <StructuredMessageRenderer structuredMessage={itineraryOnly} />
    </div>
  );
}
